module.exports = __webpack_public_path__ + "static/media/r25.3a279551.png";